import { render, staticRenderFns } from "./editCertify.vue?vue&type=template&id=4be3dc0e&scoped=true&"
import script from "./editCertify.vue?vue&type=script&lang=js&"
export * from "./editCertify.vue?vue&type=script&lang=js&"
import style0 from "./editCertify.vue?vue&type=style&index=0&id=4be3dc0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be3dc0e",
  null
  
)

export default component.exports